var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-reference-house-container" }, [
    _c("h2", { staticClass: "add-house-modal-heading" }, [
      _vm._v("Bostadshuset")
    ]),
    _vm._v(" "),
    _vm.isCorona
      ? _c("div", { staticClass: "row corona-options" }, [
          _c("div", { staticClass: "col-sm-5 col-sm-offset-1" }, [
            _c("h3", [_vm._v("Hustyp")]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c("div", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.houseConstructionType,
                      expression: "houseConstructionType"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "radio", id: "lowRise", value: "lowRise" },
                  domProps: {
                    checked: _vm._q(_vm.houseConstructionType, "lowRise")
                  },
                  on: {
                    change: function($event) {
                      _vm.houseConstructionType = "lowRise"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "lowRise" } },
                  [_vm._v("Lamellhus")]
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.houseConstructionType,
                      expression: "houseConstructionType"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "radio",
                    id: "towerBlock",
                    value: "towerBlock"
                  },
                  domProps: {
                    checked: _vm._q(_vm.houseConstructionType, "towerBlock")
                  },
                  on: {
                    change: function($event) {
                      _vm.houseConstructionType = "towerBlock"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "towerBlock" }
                  },
                  [_vm._v("Punkthus")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.isLowRiseHouse
            ? _c("div", { staticClass: "col-sm-5 col-sm-offset-1" }, [
                _c("h3", [_vm._v("Loftgång")]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group" }, [
                  _c("div", { staticClass: "radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasExteriorCorridor,
                          expression: "hasExteriorCorridor"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "radio", id: "exteriorCorridorFalse" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.hasExteriorCorridor, false)
                      },
                      on: {
                        change: function($event) {
                          _vm.hasExteriorCorridor = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "exteriorCorridorFalse" }
                      },
                      [_vm._v("Nej")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasExteriorCorridor,
                          expression: "hasExteriorCorridor"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "radio", id: "exteriorCorridorTrue" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.hasExteriorCorridor, true)
                      },
                      on: {
                        change: function($event) {
                          _vm.hasExteriorCorridor = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "exteriorCorridorTrue" }
                      },
                      [_vm._v("Ja")]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row custom-reference-house" }, [
      _c(
        "div",
        {
          staticClass: "col-sm-10 col-sm-offset-1 custom-reference-house-inner",
          class: { corona: _vm.isCorona }
        },
        [
          _c("h3", [_vm._v("Normalplan")]),
          _vm._v(" "),
          _c("table", { staticClass: "table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.standardFloorApartments, function(apartment, i) {
                return _c("custom-reference-house-apartment", {
                  key: apartment.id,
                  attrs: {
                    apartment: apartment,
                    showAddButton: i === 0,
                    showRemoveButton: i !== 0,
                    handleAdd: function() {
                      return _vm.addApartment(_vm.standardFloorApartments)
                    },
                    handleRemove: function(apartmentId) {
                      return _vm.removeApartment(
                        _vm.standardFloorApartments,
                        apartmentId
                      )
                    }
                  }
                })
              })
            )
          ]),
          _vm._v(" "),
          !_vm.isGroundFloorSelectorVisible
            ? _c("p", { staticClass: "groundfloor-selector-text" }, [
                _vm._v(
                  "\n                Om du vill fylla i ett annorlunda markplan från normalplan,\n                "
                ),
                _c(
                  "a",
                  {
                    staticClass: "reference-house-filter-toggle",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showGroundFloorSelector()
                      }
                    }
                  },
                  [_vm._v("klicka här")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isGroundFloorSelectorVisible
            ? _c("p", { staticClass: "groundfloor-selector-text" }, [
                _vm._v(
                  "\n                Om markplanet inte skiljer sig från normalplanen,\n                "
                ),
                _c(
                  "a",
                  {
                    staticClass: "reference-house-filter-toggle",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.hideGroundFloorSelector()
                      }
                    }
                  },
                  [_vm._v("klicka här")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.isGroundFloorSelectorVisible
              ? _c("div", { staticClass: "groundfloor-inputs" }, [
                  _c("h3", [_vm._v("Markplan")]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Storlek")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Yta")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Antal")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.groundFloorApartments, function(apartment, i) {
                        return _c("custom-reference-house-apartment", {
                          key: apartment.id,
                          attrs: {
                            apartment: apartment,
                            showAddButton: i === 0,
                            showRemoveButton: i !== 0,
                            handleAdd: function() {
                              return _vm.addApartment(_vm.groundFloorApartments)
                            },
                            handleRemove: function(apartmentId) {
                              return _vm.removeApartment(
                                _vm.groundFloorApartments,
                                apartmentId
                              )
                            }
                          }
                        })
                      })
                    )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row top-buffer modal-actions" }, [
        _c("div", { staticClass: "col-sm-6 text-left" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.onCancel()
                }
              }
            },
            [_vm._v("Avbryt")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.onOk({
                    groundFloorApartments: _vm.groundFloorApartments,
                    standardFloorApartments: _vm.standardFloorApartments,
                    houseConstructionType: _vm.houseConstructionType,
                    hasExteriorCorridor:
                      _vm.canHaveExteriorCorridor && _vm.hasExteriorCorridor
                  })
                }
              }
            },
            [
              _c("span", { staticClass: "spinner" }, [
                _vm._v("Använd detta hus")
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Storlek")]),
        _vm._v(" "),
        _c("th", [_vm._v("Yta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Antal")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/customRefHouse.vue?vue&type=template&id=b17563b0&
// module id = 496
// module chunks = 0